import { Locality } from "./localities.model";
import { Tiers } from "./tiers.model";
import { TypeProject } from "./type-projects.model";
import { Project } from "./projects.model";


export class Lotissement {
    id: number;
    name: string;
    description: string;
    surface: string;
    locality: Locality;
    tiers: Tiers[];
    typeLotissement: TypeProject;
    projects: Project[];
    nombreTotalLot: number;

    constructor() {
        this.locality = new Locality();
        this.typeLotissement = new TypeProject();
    }
}

export class LotissementForm {
    id: number;
    name: string;
    description: string;
    surface: string;
    locality: Locality;
    tiers: number[];
    typeLotissement: number;
    projects: number[];
    nombreTotalLot: number;
    constructor() { }
}